<template>
	<div class="body-mid">
		<div style="background: #E5EDFB;">
			<div style="display: inline-block; font-size: 18px;font-weight: bold;line-height: 40px;color: white;
			padding: 0 20px;height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;">
				新建企业
			</div>
		</div>
		<div class="form">
			<div class="form-item">
				<div class="title">
					<div><span style="color: red;">*</span> 企业名称</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" v-model="serveData.name" placeholder="请输入企业名称">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div><span style="color: red;">*</span> 三证合一</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" v-model="serveData.license_num" placeholder="请输入工商营业执照号,组织机构证,税务登记证">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div><span style="color: red;">*</span> 注册地址</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" v-model="serveData.license_address" placeholder="请填写证照核准的地址">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div><span style="color: red;">*</span> 成立日期</div>
					<span>:</span>
				</div>
				<div class="inp">
					<div class="block" style="margin-bottom: 20px;">
						<el-date-picker  format="yyyy 年 MM 月 dd 日"  value-format="yyyy-MM-dd" v-model="serveData.set_up_date" type="date" placeholder="选择日期">
						</el-date-picker>
					</div>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div><span style="color: red;">*</span> 员工人数</div>
					<span>:</span>
				</div>
				<div class="inp">
					<div>
						<el-select v-model="serveData.staff_quantity" placeholder="请选择人数">
							<el-option v-for="item in Renoptions" :key="item.label" :label="item.label"
								:value="item.label">
							</el-option>
						</el-select>
					</div>
				</div>
			</div>



			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div><span style="color: red;">*</span> 行业类别 </div>
					<span>:</span>
				</div>
				<div class="inp">
					<div>
						<el-select v-model="serveData.industry_id" placeholder="请选择您的行业类别">
							<el-option v-for="item in HYLBoptions" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div><span style="color: red;">*</span> 法人姓名</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" v-model="serveData.legal_person" placeholder="请输入法定代表人姓名">
				</div>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div><span style="color: red;">*</span> 联系电话</div>
					<span>:</span>
				</div>
				<div class="inp">
					<div style="display: flex;">
						<input v-model="serveData.legal_phone" type="text" placeholder="请输入法定代表人手机号码">
						<div style="margin-left: 30px;display: flex;align-items: ;">
							<span style="line-height: 45px;">验证码:</span>
							<input type="text" style="width: 200px;margin-left: 10px;" v-model="serveData.legal_phone_captcha" placeholder="验证码">
							<p class="getCode" @click="send2" v-if="showtime2===null">获取手机验证码</p>
							<p v-else class="getCode"> {{showtime2}}</p>

						</div>
					</div>

				</div>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div><span style="color: red;">*</span> 电子邮箱</div>
					<span>:</span>
				</div>
				<div class="inp">
					<div style="display: flex;">
						<input type="text" v-model="serveData.email" placeholder="请输入法定代表人邮箱号">
						<div style="margin-left: 30px;display: flex;align-items: ;">
							<span style="line-height: 45px;">验证码:</span>
							<input type="text" style="width: 200px;margin-left: 10px;" v-model="serveData.email_catcha" placeholder="验证码">
							<p class="getCode" @click="send" v-if="showtime===null">获取邮箱验证码</p>
							<p v-else class="getCode"> {{showtime}}</p>
						</div>
					</div>

				</div>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div><span style="color: red;">*</span> 证件类型 </div>
					<span>:</span>
				</div>
				<div class="inp">
					<div>
						<el-select v-model="serveData.certificate_type" placeholder="请选择">
							<el-option v-for="item in ZJoptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div><span style="color: red;">*</span> 证件号码</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" v-model="serveData.certificate_num" placeholder="请输入法定代表人证件号码">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div style="width: 200px;"><span style="color: red;">*</span> 上传身份证正面扫描件</div>
					<span>:</span>
				</div>
				<div class="inp">
					<el-upload class="upload-demo" :on-success='uploadIdScan' 
					:headers='{token:$store.state.userInfo.token}' :action="uploadPath+'common/upload'" 
						:limit="1" :file-list="fileList1">
						<div style="width: 340px;height: 48px;background: #EEEEEE;border: 1px solid #EEEEEE;
						line-height: 48px;text-align: center;
					 ">点击上传</div>
					 </el-upload>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div style="width:180px;"><span style="color: red;">*</span> 上传营业执照扫描件</div>
					<span>:</span>
				</div>
				<div class="inp">
			<el-upload class="upload-demo" :headers='{token:$store.state.userInfo.token}' :on-success='uploadLicenseScan' 
			 :action="uploadPath+'common/upload'"
						:limit="1" :file-list="fileList2">
						<div style="width: 340px;height: 48px;background: #EEEEEE;border: 1px solid #EEEEEE;
						line-height: 48px;text-align: center;
					 ">点击上传</div>
					 </el-upload>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div><span style="color: red;">*</span> 企业电话</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" v-model="serveData.phone" placeholder="请输入公司联系电话">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div><span style="color: red;">*</span> 详细地址</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" v-model="serveData.address" style="width: 850px;" placeholder="请输人公司详细地址">
				</div>
			</div>

		</div>
		<div class="commit" @click="addNewCompany">提交认证</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fileList1: [],
				fileList2: [],
				dateValue: '',
				HYLBoptions: [],
				HYLBvalue: '',
				// :1=身份证,2=港澳通行证,3=台胞证,4=护照
				ZJoptions: [{
					value: 1,
					label: '身份证'
				}, {
					value: 2,
					label: '港澳通行证'
				},
				{
					value: 3,
					label: '台胞证'
				},{
					value: 4,
					label: '护照'
				}
				],
				ZJvalue: '',
				Renoptions: [{
					label: '0-20'
				}, {
					label: '20-99'
				},
				{
					label: '100-500'
				},
				{
					label: '500-999'
				},
				{
					label: '1000-9999'
				}
				],
				Renvalue: '',
				timeCounter: null,
				// null 则显示按钮 秒数则显示读秒
				showtime: null,
				//phone
				timeCounter2: null,
				// null 则显示按钮 秒数则显示读秒
				showtime2: null,

				serveCode: '1234',
				serveData:{
					name:'',//企业名称
					license_num:'',//三证合一
					license_address:'',//注册地址
					set_up_date:'',//成立日期
					staff_quantity:'',//员工人数
					industry_id:'',//行业id
					legal_person:'',//法人姓名
					legal_phone:'',//法人电话
					legal_phone_captcha:'',//,法人手机验证码
					email:'',//法人邮箱
					email_catcha:'',//法人邮箱验证码
					certificate_type:'',//证件类型:1=身份证,2=港澳通行证,3=台胞证,4=护照
					certificate_num:'',//证件号码
					certificate_image:'',//证件图片
					license_image:'',//执照图片,
					phone:'',//企业电话,
					address:''//地址
				}
			}
		},
		created() {
			this.getHyList()
		},
		methods: {
			async addNewCompany(){
				const company = await this.$api.addCompanyHandler({...this.serveData})
				if(company.code == 1){
					this.$message({
						message:company.msg,
						type:'success'
					})
					setTimeout(()=>{
						this.$router.go(-1)
					},300)
				}else{
					this.$message({
						message:company.msg,
						type:'warning'
					})
				}
			},
			async getHyList(){
				const list = await this.$api.getHangYeLists()
				this.HYLBoptions = list.data
			},
			countDownText(s) {
				this.showtime = `${s}s后重新获取`
			},
			uploadIdScan(file,fileList){
				if(file.code == 1){
					this.serveData.certificate_image = file.data.url
				}
			},
			uploadLicenseScan(file,fileList){
				if(file.code == 1){
					this.serveData.license_image = file.data.url
				}else{
					this.$message({
						message:file.msg,
						type:'warning'
					})
				}
			},
			// 倒计时 60秒 不需要很精准
			countDown(times) {
				const self = this;
				// 时间间隔 1秒
				const interval = 1000;
				let count = 0;
				self.timeCounter = setTimeout(countDownStart, interval);

				function countDownStart() {
					if (self.timeCounter == null) {
						return false;
					}
					count++
					self.countDownText(times - count + 1);
					if (count > times) {
						clearTimeout(self.timeCounter)
						self.showtime = null;
					} else {
						self.timeCounter = setTimeout(countDownStart, interval)
					}
				}
			},
			async send() {
				const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
				if (this.serveData.email == '') {
					this.$message.error('请填写邮箱');
					return
				}
				if (emailRegex.test(this.serveData.email)) {
					const yzcode = await this.$api.sendEmailCode({
						event: 'form',
						email: this.serveData.email
					})
					if(yzcode.code == 1){
						this.countDown(60);
						this.$message({
							message:yzcode.msg,
							type:'success'
						})
					}else{
						this.$message({
							message:yzcode.msg,
							type:'warning'
						})
					}
				} else {
					this.$message.error('邮箱格式错误');
				}
			},
			countDownText2(s) {
				this.showtime2 = `${s}s后重新获取`
			},
			// 倒计时 60秒 不需要很精准
			countDown2(times) {
				const self = this;
				// 时间间隔 1秒
				const interval = 1000;
				let count = 0;
				self.timeCounter2 = setTimeout(countDownStart, interval);

				function countDownStart() {
					if (self.timeCounter2 == null) {
						return false;
					}
					count++
					self.countDownText2(times - count + 1);
					if (count > times) {
						clearTimeout(self.timeCounter2)
						self.showtime2 = null;
					} else {
						self.timeCounter2 = setTimeout(countDownStart, interval)
					}
				}
			},
			async send2() {
				const phoneNumberRegex = /^1\d{10}$/;
				if (this.serveData.legal_phone == '') {
					this.$message.error('请填写手机号');
					return
				}
				if (phoneNumberRegex.test(this.serveData.legal_phone)) {
					const email = await this.$api.sendPhoneCode({mobile:this.serveData.legal_phone})
					if(email.code == 1){
						this.$message({
							message: email.msg,
							type: 'success'
						});
						this.countDown2(60);
					}
				} else {
					this.$message.error('手机号格式错误');
				}
			},
		},

	}
</script>

<style scoped lang="less">
	.getCode {
		width: 133px;
		height: 44px;
		border-radius: 5px;
		background: #0052D9;
		background: #0052D9;
		border: 1px solid #D2D2D2;
		color: white;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	.commit {
		width: 261px;
		height: 40px;
		background: #0052D9;
		color: white;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
		line-height: 40px;
		margin: auto;
		text-align: center;
	}

	.puls {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		color: white;
		line-height: 20px;
		cursor: pointer;
		font-size: 20px;
		background: #0052D9;
		text-align: center;
	}

	.form {
		padding: 40px 50px;
		box-sizing: border-box;

		/deep/.el-select {
			margin-bottom: 20px;
		}

		/deep/.el-textarea__inner {
			border: 1px solid #D2D2D2;
			color: black !important;
			font-family: none;
		}

		/deep/.el-input__inner {
			width: 448px;
			border: 1px solid #D2D2D2;
			line-height: 45px;
			font-size: 18px;
			color: black !important;
			height: 45px;
			box-sizing: border-box;
		}

		/deep/.el-textarea__inner,
		/deep/.el-input__inner::placeholder {
			color: #999999;
			font-size: 18px;
		}

		.form-item {
			display: flex;
			margin-bottom: 30px;
			align-items: baseline;

			.inp {
				margin-left: 40px;

				& input {
					font-size: 18px;
					padding: 0 15px;
					box-sizing: border-box;
					width: 448px;
					height: 45px;
					border: 1px solid #D2D2D2;
					border-radius: 6px;
					margin-bottom: 20px;
				}
			}

			.title {
				font-size: 18px;
				display: flex;
				align-items: center;

				&>div {
					width: 95px;
					text-align-last: justify;
				}
			}
		}
	}

	.body-mid {
		padding: 30px 0;
		margin: 0 20px;
		width: 1120px;
		box-sizing: border-box;
		background: #fff;
	}
</style>